export default __webpack_public_path__ + "static/media/KryLogo.6f266ccd.svg";